var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserFailure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15.981,
    viewBox: "0 0 16 15.981",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M35.5-866.495a5.807,5.807,0,0,0,1.576-.216,6.045,6.045,0,0,0,1.463-.628l-2.907-2.907H35.5a7.5,7.5,0,0,0-2.438.4,7.482,7.482,0,0,0-2.176,1.172,7.2,7.2,0,0,0,2.063,1.6A5.549,5.549,0,0,0,35.5-866.495Zm6.359,2.476-2.213-2.213a7.648,7.648,0,0,1-1.97.919,7.451,7.451,0,0,1-2.176.319,7.308,7.308,0,0,1-2.926-.591,7.577,7.577,0,0,1-2.382-1.6,7.575,7.575,0,0,1-1.6-2.382,7.306,7.306,0,0,1-.591-2.926,7.593,7.593,0,0,1,.309-2.157,7.719,7.719,0,0,1,.91-1.988L27-878.875l1.069-1.069,14.856,14.856Zm-.094-4.352-4.277-4.277a2.421,2.421,0,0,0,.478-.8,2.708,2.708,0,0,0,.159-.928,2.531,2.531,0,0,0-.769-1.857A2.53,2.53,0,0,0,35.5-877a2.708,2.708,0,0,0-.928.16,2.419,2.419,0,0,0-.8.478l-2.4-2.4a7.648,7.648,0,0,1,1.97-.919A7.387,7.387,0,0,1,35.5-880a7.306,7.306,0,0,1,2.926.591,7.577,7.577,0,0,1,2.382,1.6,7.576,7.576,0,0,1,1.6,2.382A7.306,7.306,0,0,1,43-872.5a7.384,7.384,0,0,1-.319,2.157A7.647,7.647,0,0,1,41.762-868.37Z",
    transform: "translate(-27 880)",
    fill: "#f01445"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFailure);
export default __webpack_public_path__ + "static/media/user_failure.82196730de7451cc0f7aef4938fa482f.svg";
export { ForwardRef as ReactComponent };